var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgServices02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 251,
    height: 255,
    viewBox: "0 0 251 255",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118.152 0.178648C144.502 -1.88481 167.84 14.3185 190.102 28.5543C213.772 43.6897 244.219 57.1986 250.219 84.6299C256.192 111.939 226.174 133.224 218.899 160.215C210.972 189.622 230.186 229.795 206.069 248.418C182.133 266.901 148.265 240.891 118.152 238.011C92.0739 235.516 64.0108 246.36 41.6691 232.691C18.7174 218.65 2.48374 192.607 0.148665 165.818C-2.02555 140.874 20.2119 121.936 30.0063 98.8896C38.5999 78.669 39.3157 55.608 53.9531 39.2161C71.0492 20.0707 92.551 2.18341 118.152 0.178648Z",
    fill: "#88CCDD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServices02);
export default __webpack_public_path__ + "static/media/services-02.c52f9bab462ad7c7a2a96a44df5f6a04.svg";
export { ForwardRef as ReactComponent };